import React, { useState, useEffect } from 'react';
import { StarIcon } from '@heroicons/react/24/solid';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const testimonials = [
  {
    id: 1,
    name: 'Ayşe Yılmaz',
    rating: 5,
    text: 'Minela Kids\'ten aldığım ürünlerden çok memnun kaldım. Kalitesi harika ve çocuğum çok sevdi!',
    date: '2 gün önce',
    verified: true
  },
  {
    id: 2,
    name: 'Mehmet Demir',
    rating: 5,
    text: 'Hızlı teslimat ve harika müşteri hizmetleri. Kesinlikle tavsiye ediyorum.',
    date: '5 gün önce',
    verified: true
  },
  {
    id: 3,
    name: 'Zeynep Kaya',
    rating: 4,
    text: 'Ürünler çok şık ve kaliteli. Fiyatlar da makul. Tekrar alışveriş yapacağım.',
    date: '1 hafta önce',
    verified: true
  },
  {
    id: 4,
    name: 'Can Öztürk',
    rating: 5,
    text: 'Bebek kıyafetleri çok yumuşak ve rahat. Bebeğim hiç rahatsız olmadı.',
    date: '2 hafta önce',
    verified: true
  },
  {
    id: 5,
    name: 'Elif Arslan',
    rating: 5,
    text: 'Oyuncakların kalitesi mükemmel. Çocuğum çok eğleniyor ve güvenli hissediyorum.',
    date: '3 hafta önce',
    verified: true
  }
];

const TestimonialsSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => 
        prev >= testimonials.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const goToPrevious = () => {
    setCurrentIndex(prev => 
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex(prev => 
      prev >= testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <div className="w-full bg-gradient-to-b from-purple-50 to-white py-12">
      <div className="max-w-5xl mx-auto px-4">
        {/* Başlık */}
        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            💬 Müşteri Yorumları
          </h2>
          <p className="text-gray-600 text-sm">
            Müşterilerimizin deneyimlerini keşfedin
          </p>
        </div>

        {/* Slider */}
        <div className="relative max-w-3xl mx-auto">
          {/* Navigation Buttons */}
          <button
            onClick={goToPrevious}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 sm:-translate-x-12 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-50 transition-all"
          >
            <ChevronLeftIcon className="w-5 h-5" />
          </button>
          <button
            onClick={goToNext}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 sm:translate-x-12 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-50 transition-all"
          >
            <ChevronRightIcon className="w-5 h-5" />
          </button>

          {/* Testimonial Card */}
          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 min-h-[250px] flex flex-col justify-center">
            {/* Rating Stars */}
            <div className="flex justify-center gap-1 mb-4">
              {[...Array(5)].map((_, idx) => (
                <StarIcon
                  key={idx}
                  className={`w-5 h-5 ${
                    idx < currentTestimonial.rating
                      ? 'text-yellow-400'
                      : 'text-gray-300'
                  }`}
                />
              ))}
            </div>

            {/* Review Text */}
            <p className="text-gray-700 text-base sm:text-lg text-center mb-6 leading-relaxed italic">
              "{currentTestimonial.text}"
            </p>

            {/* Customer Info */}
            <div className="flex flex-col items-center">
              <div className="flex items-center gap-2 mb-1">
                <p className="font-semibold text-gray-900 text-base">
                  {currentTestimonial.name}
                </p>
                {currentTestimonial.verified && (
                  <span className="bg-brand-green text-white text-xs px-2 py-0.5 rounded-full font-semibold">
                    ✓ Onaylı
                  </span>
                )}
              </div>
              <p className="text-gray-500 text-xs">{currentTestimonial.date}</p>
            </div>
          </div>

          {/* Indicators */}
          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`h-1.5 rounded-full transition-all ${
                  currentIndex === idx 
                    ? 'bg-brand-green w-6' 
                    : 'bg-gray-300 w-1.5'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Trust Badge */}
        <div className="text-center mt-8">
          <div className="inline-flex items-center gap-2 bg-yellow-50 px-4 py-2 rounded-full">
            <StarIcon className="w-5 h-5 text-yellow-400" />
            <span className="font-bold text-gray-900 text-sm">4.9/5</span>
            <span className="text-gray-600 text-sm">·</span>
            <span className="text-gray-600 text-sm">2,450+ Mutlu Müşteri</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSlider;
